import React, { useEffect, useState } from "react";
import axios from "../../axios";
import urls from "../../Utils/urls";
import { useAbortController } from "../../hooks/useAbortController";
import { oracleConfig } from "../../Utils/constant";

const useCredentials = () => {
  const [loading, setLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    clientId: "",
    clientSecret: "",
  });
  const [links, setLinks] = useState([]);
  const [loadingLinks, setLoadingLinks] = useState(false);
  const { signal } = useAbortController();

  const userId = localStorage.getItem("apex_userid");

  useEffect(() => {
    getCredentials();
  }, []);

  useEffect(() => {
    async function getDownloadLinks() {
      setLoadingLinks(true);
      try {
        const res = await axios.get(
          urls.borrower.apiDocumentationLinks(userId),
          oracleConfig,
          {
            signal,
          }
        );
        const data = res.data.items;
        setLinks(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingLinks(false);
      }
    }

    getDownloadLinks();
  }, []);

  async function getCredentials() {
    setLoading(true);
    try {
      const res = await axios.post(
        urls.borrower.apiCredentials(userId),
        {},
        oracleConfig
      );

      const data = res.data;
      setCredentials({
        clientId: data.client_id,
        clientSecret: data.client_secret,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  return { getCredentials, loading, credentials, links, loadingLinks };
};

export default useCredentials;
